import React, { Component } from 'react';
import { Button, Icon, Modal, Popconfirm, Table, notification } from 'antd';
import './ListDocument.css';

import FileViewer from 'react-file-viewer';
import { downloadDocument, fetchDocumentUrl } from "../util/CandidateDocumentAPI";
import { NOTIFICATION_HEADER } from "../util/constants";

class ListDocument extends Component {
  state = {
    loadingId: null
  };

  notifyError = action => {
    notification.error({
      message: NOTIFICATION_HEADER,
      description: `Error! Cannot ${action} the document at the moment. Please try again later.`,
    });
  };

  showModal = (id, fileName) => {
    const fileNameParts = fileName.split('.');
    const fileExt = fileNameParts[fileNameParts.length - 1].toLowerCase();

    this.setState({ loadingId: id });

    // The document endpoint requires a bearer token, so fetch it first and
    // hand the viewer a local object URL instead of the protected API URL.
    fetchDocumentUrl(id)
      .then(objectUrl => {
        const release = () => URL.revokeObjectURL(objectUrl);

        Modal.info({
          title: 'File Preview',
          content: (
            <FileViewer
              fileType={fileExt}
              filePath={objectUrl}
            />
          ),
          icon: "file-search",
          width: "80%",
          maskClosable: true,
          okText: 'Close',
          onOk: release,
          onCancel: release
        });
      })
      .catch(() => this.notifyError('preview'))
      .then(() => this.setState({ loadingId: null }));
  };

  handleDownload = (id, fileName) => {
    this.setState({ loadingId: id });

    downloadDocument(id, fileName)
      .catch(() => this.notifyError('download'))
      .then(() => this.setState({ loadingId: null }));
  };

  render() {
    const { candidateDocuments = [] } = this.props;
    const { loadingId } = this.state;
    const data = [];

    candidateDocuments.forEach(candidateDocument => {
      data.push(
        {
          key: candidateDocument.id,
          fileName: candidateDocument.fileName,
          vacancy: candidateDocument.vacancy,
          allowDelete: candidateDocument.updatedBy
        }
      );
    });

    const columns = [{
      title: 'Name',
      dataIndex: 'fileName',
      key: 'fileName',
      render: (text, record) => (
        <Button loading={loadingId === record.key} onClick={() => this.showModal(record.key, text)}>{text}</Button>
      ),
    }, {
      title: 'Vacancy',
      dataIndex: 'vacancy',
      key: 'vacancy'
    }, {
      title: 'Action',
      key: 'action',
      className: 'action',
      align: 'center',
      width: "15%",
      render: (text, record) => (
        <>
          <Button
            size="small"
            loading={loadingId === record.key}
            onClick={() => this.handleDownload(record.key, record.fileName)}
          >
            <Icon type="download"/>
          </Button>
          {record.allowDelete &&
            <Popconfirm title="Sure to delete?" onConfirm={() => this.props.handleDelete(record.key)}>
              <Button type='danger' size='small' ghost style={{ marginLeft: "8px" }}><Icon type="delete"/></Button>
            </Popconfirm>
          }
        </>
      )
    }];

    return <Table columns={columns} dataSource={data} />;
  }
}

export default ListDocument;
